import React from 'react';
import COLORS from 'constants/colors';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const positions = {
  bottom: {
    top: '120%',
    left: '50%',
  },
  top: {
    bottom: '120%',
    left: '50%',
  },
  left: {
    bottom: '0%',
    left: '-160%',
  },
  right: {
    bottom: '0%',
    right: '-160%',
  },
};

const TooltipText = styled.span`
  visibility: hidden;
  width: ${({ width }) => (!width ? `60px` : width)};
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ color }) => color};
  text-align: center;
  border-radius: 3px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  margin-left: -33px;
  font-size: 12px;
  opacity: 0;
  ${TooltipWrapper}:hover & {
    visibility: visible;
    opacity: 1;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }
`;

const Tooltip = props => {
  const {
    title = 'testing',
    bgColor = '#708090',
    color = '#fff',
    width = '60px',
    children,
    ...extraProps
  } = props;
  let { position } = props;

  if (!position || !Object.keys(positions).includes(position)) {
    position = 'top';
  }

  return (
    <TooltipWrapper {...extraProps}>
      {children}
      <TooltipText
        style={{ ...positions[position] }}
        bgColor={bgColor}
        color={color}
        width={width}
      >
        {title}
      </TooltipText>
    </TooltipWrapper>
  );
};

Tooltip.propTypes = {
  title: PropTypes.string,
  bgColor: PropTypes.string,
  color: PropTypes.string,
  position: PropTypes.string,
  children: PropTypes.shape({}).isRequired,
  width: PropTypes.string,
};

Tooltip.defaultProps = {
  title: 'tooltip',
  bgColor: COLORS.SLATE_GRAY,
  color: COLORS.WHITE,
  position: 'top',
  width: '60px',
};

export default Tooltip;
